import alertsReducer from './reducers';
import * as allAlertsActions from './actions';

export { default as alertsOperations } from './operations';
export { default as alertsTypes } from './types';
export const alertsActions = allAlertsActions;

export default alertsReducer;
